import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ReduxUseRecord from '../../../../store/actionreducers/useRecord';
import ReduxCompany from '../../../../store/actionreducers/company';
import {FusePageSimple} from '../../../../@fuse/index';
import UseRecordList from './UseRecordList';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import UecareListHeader from "../../../../components/header/UecareListHeader";
import UseRecordSideBar from "./UseRecordSideBar";

class CompanyUseRecordApp extends Component {

    async componentDidMount() {
        try {
            const companyId = this.props.match.params.companyId;

            if (companyId === 'all') {
                await this.props.getUseRecords();
            } else {
                await this.props.getCompany(companyId);
                await this.props.getUseRecordsByCompanyId(companyId);
            }
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader
                            title='點數紀錄'
                            icon='search'
                            arrowBack={{
                                linkTo: '/apps/company/all',
                                label: '企業列表'
                            }}/>
                    }
                    leftSidebarContent={
                        <UseRecordSideBar sidebarType='company'/>
                    }
                    content={
                        <UseRecordList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <UecareAlertDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    avatar: {},
    layoutHeader: {
        height: 160,
        minHeight: 160
    },
    layoutContentCardWrapper: {
        padding: 24,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompany: ReduxCompany.ActionCreator.getCompany,
        getUseRecords: ReduxUseRecord.ActionCreator.getUseRecords,
        getUseRecordsByCompanyId: ReduxUseRecord.ActionCreator.getUseRecordsByCompanyId,
    }, dispatch);
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(null, mapDispatchToProps)(CompanyUseRecordApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/CompanyUseRecordApp.js